var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.navItem)?_c('li',{staticClass:"nav-item px-3 py-2"},[_c('a',{staticClass:"nav-link signup-link",class:{
      'font-weight-semibold text-primary': _vm.emphasis,
      'sub-active': _vm.signupIsActive,
    },on:{"click":_vm.sponsorCheck}},[_vm._t("default")],2)]):_c('b-button',{class:{ 'signup-link': true },attrs:{"pill":_vm.pill,"size":_vm.size,"variant":_vm.variant},on:{"click":_vm.sponsorCheck}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }